import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { adminProductsAPI, adminOrdersAPI, adminStatsAPI } from './adminApi';
import s from './AdminDashboard.module.css';

const fmt = (n) => `₦${Number(n || 0).toLocaleString()}`;
const STATUS_COLOR = {
  pending:'#F59E0B', pending_payment:'#3B82F6', paid:'#10B981',
  shipped:'#8B5CF6', delivered:'#10B981', cancelled:'#EF4444',
};

export default function AdminDashboard() {
  const [stats,   setStats]   = useState(null);
  const [orders,  setOrders]  = useState([]);
  const [pending, setPending] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      adminStatsAPI.dashboard(),
      adminOrdersAPI.list({ per_page: 5 }),
      adminProductsAPI.pending(),
    ]).then(([s, o, p]) => {
      setStats(s.data);
      setOrders(o.data.orders || []);
      setPending(p.data.products || []);
    }).catch(console.error).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className={s.loading}><div className={s.spin} /></div>;

  return (
    <div className={s.page}>
      <div className={s.header}>
        <div>
          <h1 className={s.title}>Dashboard</h1>
          <p className={s.sub}>{new Date().toLocaleDateString('en-NG', { weekday:'long', day:'numeric', month:'long', year:'numeric' })}</p>
        </div>
      </div>

      <div className={s.statsGrid}>
        {[
          { label:'Active Products',   value: stats?.products?.active   || 0, icon:'🛍', color:'#10B981', to:'/admin/products' },
          { label:'Pending Review',    value: stats?.products?.pending  || 0, icon:'⏳', color:'#F59E0B', to:'/admin/pending'  },
          { label:'Total Orders',      value: stats?.orders?.total      || 0, icon:'📦', color:'#3B82F6', to:'/admin/orders'   },
          { label:'Seller Apps',       value: stats?.sellers?.pending   || 0, icon:'🏪', color:'#E8420A', to:'/admin/sellers'  },
        ].map(stat => (
          <Link key={stat.label} to={stat.to} className={s.stat}>
            <div className={s.statTop}>
              <span className={s.statIcon}>{stat.icon}</span>
              <span className={s.statVal} style={{ color: stat.color }}>{stat.value}</span>
            </div>
            <p className={s.statLabel}>{stat.label}</p>
          </Link>
        ))}
      </div>

      <div className={s.grid2}>
        <div className={s.card}>
          <div className={s.cardHead}>
            <h3 className={s.cardTitle}>Recent Orders</h3>
            <Link to="/admin/orders" className={s.cardLink}>View all →</Link>
          </div>
          {orders.length === 0 ? <p className={s.empty}>No orders yet</p> : orders.map(o => (
            <div key={o.id} className={s.orderRow}>
              <div className={s.orderLeft}>
                <p className={s.orderId}>Order #{o.id}</p>
                <p className={s.orderDate}>{new Date(o.createdAt).toLocaleDateString()}</p>
              </div>
              <p className={s.orderTotal}>{fmt(o.total)}</p>
              <span className={s.badge} style={{ color: STATUS_COLOR[o.status], background: STATUS_COLOR[o.status] + '18' }}>
                {o.statusLabel || o.status}
              </span>
            </div>
          ))}
        </div>

        <div className={s.card}>
          <div className={s.cardHead}>
            <h3 className={s.cardTitle}>Pending Products</h3>
            <Link to="/admin/pending" className={s.cardLink}>Review all →</Link>
          </div>
          {pending.length === 0 ? <p className={s.empty}>✅ All caught up!</p> : pending.slice(0,5).map(p => (
            <div key={p.id} className={s.pendingRow}>
              {p.image_url
                ? <img src={p.image_url} alt={p.name} className={s.pendingImg} />
                : <div className={s.pendingPlaceholder}>📦</div>
              }
              <div className={s.pendingInfo}>
                <p className={s.pendingName}>{p.name}</p>
                <p className={s.pendingSeller}>{p.seller_name}</p>
              </div>
              <p className={s.pendingPrice}>₦{Number(p.price).toLocaleString()}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
